import React, { useState, useEffect } from "react";
import {
  useTable,
  usePagination,
  useSortBy,
  useExpanded,
  useGlobalFilter,
  useRowSelect,
} from "react-table";
import { includes, find } from "lodash";
// import AggregatePlanningModal from "../plannings/AggregatePlanningModal";
import AggregateBookingModal from "../bookings/AggregateBookingModal";
import { getUser } from "../../../services/authService";
import { responseOnAggregateFromJD, uploadAggregateDailyPlan, updateAggregateShipment, getMaxAggregateContainerCount } from "../../../services/aggregateDataService";
import * as actionTypes from "../../../store/ActionTypes";
import { dispatcher } from "../../../store/storeHelpers";
import {
  AGGREGATE_DAILY_CONTAINER_BOOKING_JD_TEAM,
  // AGGREGATE_DAILY_CONTAINER_BOOKING_PUNE_TEAM,
  AGGREGATE_DAILY_CONTAINER_BOOKING_PUNE_TEAM_WITH_DELETE
} from "../../columns/aggregateBookingColumns";
import { defaultColumn } from "../cells/editable/aggregateEditableCell";
import ActionCell from "../cells/tableOtherComponents/ActionCell";
import DataCell from "../cells/tableOtherComponents/DataCell";
// import MainTablePagination from "./MainTablePagination";
import AggregateActionCenter from "../action-center/AggregateActionCenter";
import { toast } from "react-toastify";
import {
  bookingUpdateEmailRecepients,
  CC_bookingUpdateEmailRecepients,
  htmlEmailSend,
} from "../../../services/emailService";
import { jdResponseMailBody } from "../../../email-template/planUploadMail";
import { TableCheckbox } from "./TableCheckbox";
import DeleteModal from "../DeleteModal";
import { filter } from "lodash";
import moment from "moment";
import MainTablePaginationAdv from "./MainTablePaginationAdv";
import { aggregateDataCreatorForStore } from "../../../utils/dataFilter";
import { PulseLoader } from "react-spinners";


function AggregateTable({
  tableData,
  reasons,
  date,
  setDate,
  setShowCreateNewSchedule,
  setShowDailyPlanUploader,
  dataExportHandler,
  subModule,
  type,
  newSelectedFlatRows,
  setNewSelectedFlatRows,
  aggregateTemplateFileExportHandler,
  filteredUserAccessData,
  noDataState,
  setNoDataState,
  countData,
  setCountData,
  transporterList
}) {
  const user = getUser();
  const [bookingModalId, setBookingModalId] = useState("");
  // const [planningModalId, setPlanningModalId] = useState("");
  const [columns, setColumn] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(null);
  const [sortTableData, setSortTableData] = useState([])
  const [showDisableCell, setShowDisableCell] = useState(false)
  const [showDisableCellForJD, setShowDisableCellForJD] = useState(false)
  const [showholddialog,setholdmodal] = useState("");

  const [disableSplitBtn, setDisableSplitBtn] = useState({
    id:"",
    status:false
  })

  var allowToEdit = filter(filteredUserAccessData,{Edit:1}).length > 0
  var allowToDelete = filter(filteredUserAccessData,{Delete:1}).length > 0
	var allowToAdd = filter(filteredUserAccessData, { Add: 1 }).length > 0;
  var allowToHold = filter(filteredUserAccessData, { Hold: 1 }).length > 0;


  // function showCheckbox(row){
  //   if (row.original.Container_Count !== "") {
  //     return true
  //   } else return false
  // }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
    setPageSize,
    canPreviousPage,
    setGlobalFilter,
    prepareRow,
    selectedFlatRows,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data: tableData,
      defaultColumn,
      autoResetPage: false,
      initialState: { pageSize: 50 },
      autoResetExpanded: false,
      autoResetGlobalFilter: false,
      showDisableCell,
      setShowDisableCell,
      showDisableCellForJD,
      setShowDisableCellForJD,
      transporterList,
      allowToEdit,
      allowToHold,
      setholdmodal,
      date,
      showholddialog,
      setCountData
    },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <TableCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            // showCheckbox(row) && (
            <div>
              <TableCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
            // )
          ),
        },
        ...columns,
      ]);
    }
  );

  const { pageIndex, pageSize, globalFilter } = state;

  useEffect(() => {
    if (includes(user.role, "jd_team") === true) {
      return setColumn(AGGREGATE_DAILY_CONTAINER_BOOKING_JD_TEAM);
    }
    if(includes(user.role,"deleteAccess")=== true){
      return setColumn(AGGREGATE_DAILY_CONTAINER_BOOKING_PUNE_TEAM_WITH_DELETE);
    } else return setColumn(AGGREGATE_DAILY_CONTAINER_BOOKING_PUNE_TEAM_WITH_DELETE);
  }, [user]);

  useEffect(()=>{
    var sameCountry = {};
    for (const item of tableData) {
      if (sameCountry.hasOwnProperty(item.Country)) {
        sameCountry[item.Country].push(item.subRows);
      } else {
        sameCountry[item.Country] = item.subRows;
      }
    }
    setSortTableData(sameCountry)
  },[tableData])

  const handleJDResponse = async (shipment, response) => {
    try {
      await responseOnAggregateFromJD({
        assignContainerAggregateId: shipment.AssignContainerAggregateId,
        Country: shipment.Country,
        DeereStatus: response,
        DeereStatusBy: user.uid,
      });
      dispatcher(actionTypes.AGGREGATE_BOOKING_STATUS_UPDATE_FROM_JD, {
        DailyContainerPlanningAggregateId:
          shipment.DailyContainerPlanningAggregateId,
        Country: shipment.Country,
        AssignContainerAggregateId: shipment.AssignContainerAggregateId,
        DeereStatus: response,
      });
      if (response === "Approved") {
        toast.success("Shipment has been approved");
        await htmlEmailSend(
          bookingUpdateEmailRecepients,
          CC_bookingUpdateEmailRecepients,
          "Status updated",
          jdResponseMailBody(shipment, "Aggregate", "Approved")
        );
      }
      if (response === "Cancelled") {
        toast.success("Shipment has been rejected");
        await htmlEmailSend(
          bookingUpdateEmailRecepients,
          CC_bookingUpdateEmailRecepients,
          "Status updated",
          jdResponseMailBody(shipment, "Aggregate", "Cancelled")
        );
      }
    } catch (error) {}
  };

  const bookingProcessController = (data, subRow,cell) => {
    if (allowToEdit) {
      // if (includes(user.role, "ata_pune")) {
      if (data["STATUS"] === "Not Booked" && subRow.length === 0) return true;
      if (data["STATUS"] === "Approved" && subRow.length === 0) return true;
      if(cell) {
        if (data["STATUS"] === "Hold" && subRow.length === 0 && allowToHold && cell?.column.id==="Holdtoggle") return true;
      }
     if(!cell){
      if (data["STATUS"] === "Hold" && subRow.length === 0 && allowToHold) return true;
     }      else return false;
      // }
    } else return false;
  };

  // const planningProcessController = (data, subRow) => {
  //   if (allowToEdit) {
  //     // if (includes(user.role, "ata_pune")) {
  //     if (
  //       data["STATUS"] === "Booked" &&
  //       !data["Container_Number"] &&
  //       subRow.length === 0
  //     )
  //       return true;
  //     else return false;
  //     // }
  //   } else return false;
  // };

  const cellRenderHandler = (cell) => {
    if (cell.column.id === "action" && cell.row.subRows.length === 0)
      return "action";
    if (cell.column.id === "expander" && cell.row.subRows.length === 0)
      return "expander";
    if (cell.column.id === "Delete" && allowToDelete)
      return "Delete";
    if(cell.column.id === "Add" && cell.row.subRows.length === 0 && allowToAdd)
      return "Add Row"
    else return "data";
  };

  useEffect(() => {
    setNewSelectedFlatRows(selectedFlatRows)
  },[selectedFlatRows, setNewSelectedFlatRows])

  function deleteClickhandler(cell) {
    setShowDeleteModal(cell);
  }

  async function addRowHandler(cell) {
    setDisableSplitBtn({
      id : cell.row.original.DailyContainerPlanningAggregateId,
      status : true
    })
    const resp = await getMaxAggregateContainerCount(date);
    const newObj = {
      date: moment(cell.row.original.Date, "DD-MM-YYYY").format("YYYY-MM-DD"),
      country: cell.row.original.Country,
      partNumber: cell.row.original.PartNumber,
      category: cell.row.original.Category,
      subCategory: String(cell.row.original.SubCategory),
      quantity: cell.row.original.Quantity,
      container_Count: 1,
      container_Type: cell.row.original.Container_Type,
      remark: cell.row.original.Remark,
      created_By: getUser().uid,
      containerId:(resp.data[0].ContainerId + 1).toString()
    }
   
    try {
      const response = await uploadAggregateDailyPlan([newObj])
      const getNewIdWithBracket = response.data.Result.split(":")[1]
      const getNewId = getNewIdWithBracket.split("(").join("").split(")").join("")
      tableData.map(async(item)=>{
        if(item.Country === cell.row.original.Country){
          const clickedRowContainerCount = find(item.subRows,{DailyContainerPlanningAggregateId : cell.row.original.DailyContainerPlanningAggregateId})
          clickedRowContainerCount.Container_Count = (clickedRowContainerCount.Container_Count - 1).toString()
          item.Quantity = parseInt(item.Quantity) + parseInt(cell.row.original.Quantity)
          let containerIdCount = resp.data[0].ContainerId + 1
          
          item.subRows.push({
            Date : cell.row.original.Date,
            Country: cell.row.original.Country,
            PartNumber: cell.row.original.PartNumber,
            Category: cell.row.original.Category,
            SubCategory: cell.row.original.SubCategory,
            Quantity: cell.row.original.Quantity,
            Container_Count: "1",
            Container_Type: cell.row.original.Container_Type,
            Remark: cell.row.original.Remark,
            created_By: getUser().uid,
            DailyContainerPlanningAggregateId : getNewId,
            containerId : containerIdCount.toString()
          });
          await updateAggregateShipment({
            DailyContainerPlanningAggregateId:
              cell.row.original.DailyContainerPlanningAggregateId,
            ColumnName: "Container_Count",
            Value: clickedRowContainerCount.Container_Count,
            PrevVal: cell.row.original["Container_Count"],
          })
        }
      })
      dispatcher(actionTypes.AGGREGATE_BOOKING_LOADED, aggregateDataCreatorForStore(tableData))
      setDisableSplitBtn({
        id : cell.row.original.DailyContainerPlanningAggregateId,
        status : false
      })
    } catch (error) {
      setDisableSplitBtn({
        id : cell.row.original.DailyContainerPlanningAggregateId,
        status : false
      })
      toast.error('Unable to add row...please try again.')
    }
  }

  function ApprovalPending(cell) {
    if (cell.row.original.STATUS === "Pending") {
      return true;
    } else return false;
  }

  function coloredSubrow(cell) {
    if(cell){
      if(cell.row.original.Date === moment(date).format("DD-MM-YYYY")){
        return "sub-row"
      }else{
        return "sub-row-carryforward"
      }
    }
  }

  return (
    <>
      {/* <DeleteModal
        show={showDeleteModal}
        hide={() => setShowDeleteModal(false)}
        label="delete"
      /> */}
      <div className="table_actions">
        {/* <Form.Group>
          <Form.Control
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="hiden-inp"
            placeholder="search here.."
          />
        </Form.Group> */}
        <AggregateActionCenter
          date={date}
          setDate={setDate}
          setShowCreateNewSchedule={setShowCreateNewSchedule}
          setShowDailyPlanUploader={setShowDailyPlanUploader}
          dataExportHandler={dataExportHandler}
          tableData={tableData}
          selectedFlatRows={selectedFlatRows}
          sortTableData={sortTableData}
          subModule={subModule}
          allColumns={allColumns}
          getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          type={type}
          newSelectedFlatRows={newSelectedFlatRows}
          setNewSelectedFlatRows={setNewSelectedFlatRows}
          aggregateTemplateFileExportHandler={
            aggregateTemplateFileExportHandler
          }
          filteredUserAccessData={filteredUserAccessData}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          setCountData={setCountData}
          setNoDataState={setNoDataState}
        />
      </div>
      {!noDataState && (
        <>
          <div className="table_container">
            <table {...getTableProps()} className="table mtbs">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        {column.id !== "selection" && (
                          <i
                            className={
                              column.isSorted
                                ? column.isSortedDesc
                                  ? "fi fi-rr-angle-small-down head-icon"
                                  : "fi fi-rr-angle-small-up head-icon"
                                : "fi fi-rr-circle-small head-icon w"
                            }
                          ></i>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {bookingProcessController(row.original, row.subRows) && (
                        <AggregateBookingModal
                          show={bookingModalId === `${row.id}`}
                          handleClose={() => setBookingModalId("")}
                          data={row.original}
                          reasons={reasons}
                          selectedFlatRows={selectedFlatRows}
                          date={date}
                          countData={countData}
                          setCountData={setCountData}
                          allowToHold={allowToHold}
                          showholddialog={showholddialog}
                          setholdmodal={setholdmodal}
                        />
                      )}
                      {/* {planningProcessController(row.original, row.subRows) && (
                        <AggregatePlanningModal
                          show={planningModalId === `${row.id}`}
                          handleClose={() => setPlanningModalId("")}
                          data={row.original}
                          date={date}
                          selectedFlatRows={selectedFlatRows}
                        />
                      )} */}
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            className={
                              cell.row.subRows.length !== 0
                                ? "main-row"
                                : coloredSubrow(cell)
                            }
                          >
                            <div className="cell-wrap">
                              {cellRenderHandler(cell) === "data" && (
                                <DataCell
                                  cell={cell}
                                  setBookingModalId={setBookingModalId}
                                  // setPlanningModalId={setPlanningModalId}
                                  bookingProcessController={
                                    bookingProcessController
                                  }
                                  // planningProcessController={
                                  //   planningProcessController
                                  // }
                                />
                              )}
                              {cellRenderHandler(cell) === "action" && (
                                <ActionCell
                                  cell={cell}
                                  handleJDResponse={handleJDResponse}
                                />
                              )}
                              {cellRenderHandler(cell) === "Delete" &&
                                !ApprovalPending(cell) && (
                                  <button
                                    className="deleteBtn__Subrow"
                                    tabIndex="-1"
                                    onClick={() => deleteClickhandler(cell)}
                                  >
                                    <i className="bx bxs-trash deleteBtn"></i>
                                  </button>
                                )}
                              {cellRenderHandler(cell) === "Add Row" &&
                                  <button
                                    className="addRow__TractorSubrow"
                                    tabIndex="-1"
                                    onClick={() => addRowHandler(cell)}
                                    disabled={cell.row.original.Container_Count === "1" || cell.row.original.Booking_Number || disableSplitBtn.status || cell.row.original.STATUS==="Hold"}
                                  >
                                    {
                                      (disableSplitBtn.status && disableSplitBtn.id === cell.row.original.DailyContainerPlanningAggregateId) ? (
                                        <PulseLoader
                                          color="white"
                                          size="3px"
                                          margin="0.5px"
                                          style={{ position: "relative", top: "-3px", left: "0" }}
                                        />
                                      ) : <i
                                      class="bx bx-plus-medical"
                                      style={{
                                        marginTop: "5px",
                                        color: "white",
                                      }}
                                    ></i>
                                    }
                                  </button>
                              }
                              {cellRenderHandler(cell) === "expander" &&
                                cell.render("Cell")}
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* <MainTablePagination
        nextPage={nextPage}
        previousPage={previousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canPreviousPage={canPreviousPage}
        setPageSize={setPageSize}
      /> */}
          <MainTablePaginationAdv
            nextPage={nextPage}
            previousPage={previousPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            canPreviousPage={canPreviousPage}
            setPageSize={setPageSize}
            gotoPage={gotoPage}
            pageCount={pageCount}
          />
        </>
      )}
      {showDeleteModal && (
        <DeleteModal
          show={showDeleteModal}
          hide={() => setShowDeleteModal(null)}
          dataType="Aggregate"
          tableData={tableData}
          label="delete"
          date={date}
          setNoDataState={setNoDataState}
        />
      )}
    </>
  );
}

export default AggregateTable;
